import React from 'react';
import { motion } from 'framer-motion';
import { Plus, Clock } from 'lucide-react';
import { MealSummary } from './MealSummary';
import { useMealStore } from '../../store/mealStore';

export function MealsList() {
  const { meals } = useMealStore();
  const todayStart = new Date().setHours(0, 0, 0, 0);
  const todayEnd = new Date().setHours(23, 59, 59, 999);

  const todaysMeals = meals
    .filter(meal => {
      const mealTime = new Date(meal.time).getTime();
      return mealTime >= todayStart && mealTime <= todayEnd;
    })
    .sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime());

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className="space-y-4"
    >
      <div className="flex items-center justify-between">
        <h3 className="font-medium">Today's Meals</h3>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Clock className="w-4 h-4" />
          <span>{new Date().toLocaleDateString()}</span>
        </div>
      </div>

      <div className="space-y-3">
        {todaysMeals.length === 0 ? (
          <div className="theme-card p-8 text-center">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
              <Plus className="w-6 h-6 text-primary" />
            </div>
            <p className="text-muted-foreground">No meals logged today</p>
            <p className="text-sm text-muted-foreground mt-1">
              Search and add foods to get started
            </p>
          </div>
        ) : (
          todaysMeals.map((meal) => (
            <MealSummary key={meal.id} meal={meal} />
          ))
        )}
      </div>
    </motion.div>
  );
}